import { ReactNode } from 'react';

import { MenuList } from '@mui/material';

import { DEFAULT_BORDER } from 'src/constants';

export default function TabMenuList({ children = null }: Readonly<{ children?: ReactNode }>) {
    return (
        <MenuList
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '0',
                listStyle: 'none',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                maxWidth: '100%',
                width: '100%',
                scrollbarWidth: 'thin',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                borderColor: DEFAULT_BORDER.borderColor,
            }}
        >
            {children}
        </MenuList>
    );
}
